import * as React from "react";
import { CrossLOBLinksProps } from "./typings";
import { UitkIcon } from "uitk-react-icons";
import { ItemKeyHelper } from "../../utility/ItemKeyHelper";
import { TrackedLink } from "components/utility/analytics/TrackedLink";
import { UitkLink } from "uitk-react-link";

export const CrossLOBLinks = (props: CrossLOBLinksProps) => {
  const flexComponent = props.flexComponent;
  const links = flexComponent.model && flexComponent.model.links;
  const keyHelper = new ItemKeyHelper("CrossLOBLinks");

  if (!flexComponent || !links) {
    return null;
  }

  return (
    <div
      id={flexComponent.id}
      className="CrossLOBLinks all-cell-1-1 uitk-grid uitk-cell all-b-padding-three all-t-padding-three"
      data-fm={flexComponent.fmId}
      data-fm-title-id={flexComponent.fmTitleId}
    >
      {links.map(
        el =>
          IconMap[el.icon] && (
            <div className="uitk-cell" key={keyHelper.next()}>
              <UitkLink>
                <TrackedLink href={el.url} rfrr={el.icon} moduleName="CrossLOBLinks">
                  <UitkIcon name={IconMap[el.icon]} />
                  {el.text}
                </TrackedLink>
              </UitkLink>
            </div>
          )
      )}
    </div>
  );
};

//This map contains the mapping for the icon types from the backend response to corresponding UitkIcon
const IconMap = {
  flights: "lob_flights",
  house: "lob_vacation_rentals",
  hotels: "lob_hotels",
  cars: "lob_cars",
  packages: "lob_packages",
  activities: "lob_activities"
};

export default CrossLOBLinks;
